<template>
  <div class="local-home">
    <h1>{{ msg }}</h1>

    <p>
    空間知能化のお勉強をしましょう。
    </p>

<h2>
スマートホーム（クラウド制御）の概要：工事中
</h2>

<h4>
もくじ
</h4>

<div class="talka">
<ol>
<li>
<a href="#1">スマートホーム（クラウド制御）の概要</a>
</li>
<li>
<a href="#2">Home Graph</a>
</li>
<li>
<a href="#3">デバイスのタイプと特性</a>
</li>
<li>
<a href="#4">スマートホームインテント</a>
</li>
</ol>

</div>


<h3 id="1">
1.スマートホーム（クラウド制御）の概要
</h3>

<div class="talka">

<h4>
ユーザーにとってのメリット
</h4>

<p>
ユーザーにとってのメリットには、ユーザーエンゲージメントの深化、デバイスの販売促進、ブランド価値の向上などがあります。
</p>

<ul>
<li>
ユーザーエンゲージメントを深める：
</li>
<ol>
<li>
10億のアシスタントデバイスにまたがってユーザーにアプローチし、見つけやすさを向上させ、セットアップからの摩擦を取り除きます
</li>
</ol>
<li>
販売を促進する：
</li>
<ol>
<li>
ショッピングオン検索で見つけてもらいやすくなり、小売業者やインストーラーのチャネル全体でフィーチャーされる資格を高めます。
</li>
</ol>
<li>
ブランドの価値を高める：
</li>
<ol>
<li>
思いやりのある家の中心にいる。
</li>
<li>
信頼性と豊富な機能により、ユーザーはブランドを知ることができます。
</li>
</ol>
</ul>

<h4>
デバイスをGoogleアシスタントに接続する
</h4>

<ul>
<li>
デバイスをGoogleアシスタントに接続するには、スマートホームアクションを作成する必要があります。
</li>
<li>
アシスタントは、ユーザーがアクションをトリガーする方法（複数の言語）を処理し、ホームグラフを通じて関連するメタデータを提供します（ユーザーの部屋に基づく特定のデバイスなど）。
</li>
<li>
あなたがする必要があるのはあなたのサービスのリクエストに応答することだけです。
</li>
</ul>

<h4>
理解するには：
</h4>

<ul>
<li>
アシスタントがスマートホームアクションをトリガーする方法とホームグラフが機能する方法については、<a href="https://developers.google.com/assistant/smarthome/concepts">概念</a>を参照してください 。
</li>
<li>
スマートホームアクションを構築するために必要なものについては、<a href="https://developers.google.com/assistant/smarthome/overview">develop</a>を参照してください。
</li>
<li>
サンプルのスマートホームアクションはどのようなものかは、<a href="https://developers.google.com/assistant/smarthome/samples">サンプル</a>を参照して下さい。
</li>
</ul>

<p>
アクションの開発を開始するには、<a href="https://console.actions.google.com/u/0/">アクションコンソール</a>に移動します 。
</p>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/smart-home.svg" width="90%">
<figcaption align="center">スマートホームのイメージ図</figcaption>
</figure>

</div>

<h3 id="2">
2.Home Graph
</h3>

<p>
Home Graphは、本質的にはあなたの家の論理的な地図です。
</p>

<div class="talka">

<h4>
Home Graphの概要
</h4>

<ul>
<li>
スマートホームアクションは、ホームとそのデバイスに関するコンテキストデータを格納および提供するデータベースであるHome Graphに依存しています。
</li>
<li>
Home Graphデータベースには、構造（たとえば、家やオフィス）、部屋（たとえば、寝室やリビングルーム）、デバイス（たとえば、スピーカーや電球）に関する情報が格納されています。
</li>
<li>
たとえば、ホームグラフは、照明、テレビ、スピーカーなど、さまざまなメーカーの複数の種類のデバイスを含むリビングルームのある家の概念を格納できます。
</li>
<li>
この情報は、適切なコンテキストに基づいてユーザーリクエストを実行するために、Googleアシスタントが利用できます。
</li>
<li>
電球が点灯しているかどうかなどの状態データは長期的には保存されません。これは一時的なものであり、ホームグラフでのみ使用されます。
</li>
</ul>

<h4>
Home Graphの利点：
</h4>

<ul>
<li>
暗黙的なコマンド。
</li>
<ol>
<li>
「あなた」と「Google Homeデバイス」と「照明」は同じ部屋にあります。
</li>
<li>
あなたが言わなければならないすべてはライトをつけることです。
</li>
<li>
ライトがある部屋を指定する必要はありません。
</li>
</ol>
<li>
明示的なターゲティングをより適切に制御します。
</li>
<ol>
<li>
別の部屋にいる間は、照明が複数のメーカーのものであっても、キッチンの照明を消すことができます。
</li>
<li>
スマートホームインテントは、ホームグラフで識別される特定の部屋に対して決定されます。
</li>
</ol>

</ul>

<h4>
構造（Structure）の構成：
</h4>

<p>
Google Homeアプリを使用すると、複数の家を管理できる複数の構造を設定できます。
<br>各構造には、独自の部屋とデバイスのセットがあります。構造は以下で構成されます。
</p>

<ul>
<li>
マネージャー-構造の所有者のアカウント。
</li>
<ol>
<li>
各構造には、少なくとも1人のマネージャーが必要です。
</li>
<li>
マネージャーを定義すると、マネージャーは他のユーザーと構造を共有および共有解除できます。
</li>
</ol>
<li>
部屋-構造の一部である部屋。
</li>
<li>
ラベル-「John's House」などの構造を識別するラベル。
</li>
<li>
デバイス-構造の一部であるデバイス。
</li>
<ol>
<li>
これらは、複数のメーカーのデバイスである可能性があります。
</li>
</ol>

</ul>

<h4>
ルーム（Room）の構成
</h4>

<p>
ルームは構造に属し、以下で構成されています。
</p>

<ul>
<li>
ラベル-「主寝室」などの部屋を識別するラベル。
</li>
<li>
デバイス-部屋の一部であるデバイス。
</li>
<ol>
<li>
これらは、複数のメーカーのデバイスである可能性があります。
</li>
</ol>
</ul>

<h4>
デバイス（Device）の構成
</h4>

<p>
デバイスは、少なくとも1つの構造に属している必要があり、最大1つの部屋に属することができ、次のプロパティがあります。
</p>

<ul>
<li>
タイプ-ランプ、カメラ、空調ユニットなどのデバイスのタイプ。
</li>
<li>
特性（Trait）-デバイスがサポートする特性のタイプ。
</li>
<ol>
<li>
各デバイスにはいくつかの特性があります。
</li>
<li>
例えばライトには、BrightnessやColorSettingなどの特性があります。
</li>
</ol>

</ul>

<h4>
特性（Trait）の構成
</h4>

<p>
特性には次のプロパティがあります。
</p>

<ul>
<li>
属性-デバイスに対して静的なデバイス属性。
</li>
<ol>
<li>
属性には、温度の単位、モードなどを指定できます。
</li>
</ol>
<li>
状態-デバイスのデバイス状態。
</li>
<ol>
<li>
ランプは、特定のランプの現在の明るさを示す明るさの状態を返す場合があります。
</li>
<li>
各デバイス特性は、デバイスに異なるデバイス状態を追加します。
</li>
</ol>
<li>
ラベル-「寝室のランプ」などのデバイスを識別するラベル。
</li>
</ul>

<h4>
Home Graphの例
</h4>

<ul>
<li>
図1は、構造、3つの部屋、およびいくつかのデバイスを備えたサンプル住宅を示しています。
</li>
<li>
これらの各項目には、上記の対応するプロパティがあります。
</li>
</ul>

<figure style="max-width: 420px;">
<img src="http://www.hiroict.com/img/akiko/homegraph001.png" width="80%">
<figcaption align="center">図1</figcaption>
</figure>


</div>


<h3 id="3">
3.デバイスのタイプと特性
</h3>

<div class="talka">

<h4>
デバイスのタイプと特性
</h4>

<ul>
<li>
「OK Google Google、寝室の照明をつけて」などのGoogleアシスタントとの会話では、Hey Googleが呼び出しであり、寝室の照明を つけることは文法と呼ばれています。
</li>
<ol>
<li>
Googleは文法からスマートホームインテントを決定し、それを開発者クラウドに送信します（フルフィルメント）。
</li>
<li>
その後、開発者はデバイス上でコマンドを実行し、Googleに応答を返します。
</li>
</ol>
<li>
フルフィルメントがインテントを処理してレスポンスを返した後、スマートホームアクションはホームグラフに依存します。ホームグラフを使用すると、
Googleアシスタントはデバイスを同期し、デバイスの状態をクエリし、デバイス上でコマンドを実行できます。
</li>
<li>
デバイスの種類により、Googleアシスタントはデバイスで使用する必要のある文法を認識します。
</li>
<ol>
<li>
たとえば、デバイスをライトとして定義した場合、ユーザーはGoogleアシスタントを介してHey Googleでデバイスを操作し、ライトをオンにすることができます。
</li>
</ol>
<li>
デバイスの特性は、デバイスタイプの機能を定義します。
</li>
<ol>
<li>
複数のデバイス特性を任意のデバイスタイプと組み合わせることができます。
</li>
<li>
たとえば、LightデバイスにOnOff、 Brightness、およびFanSpeed 特性を使用させることができます 。
</li>
<li>
一方でFanSpeed形質は光のために使用する最も一般的な特徴ではないかもしれない、あなたがあなたの新しいデバイスのためにしたいことをすべての形質を使用することができます。
</li>
</ol>
<li>
デバイスの特性をデバイスタイプに追加すると、デバイスは、追加した各デバイスの特性の状態を継承します。
</li>
<ol>
<li>
たとえば、OnOffトレイトを使用する と、デバイスはそのon 状態をtrueまたはfalse
</li>
</ol>
<li>
サポートされているデバイスタイプと特性の完全なリストについては、次を参照してください。
</li>
<ol>
<li>
<a href="https://developers.google.com/assistant/smarthome/guides">デバイスの種類</a>
</li>
<li>
<a href="https://developers.google.com/assistant/smarthome/traits">デバイスの特性</a>
</li>
</ol>

</ul>


</div>


<h3 id="4">
4.スマートホームインテント
</h3>

<div class="talka">

<h4>
スマートホームインテントの概要
</h4>

<ul>
<li>
スマートホームインテントは、ライトをオンにしたり、オーディオをスピーカーにキャストしたりするなど、実行するスマートホームアクションを説明するシンプルなメッセージングオブジェクトです。
</li>
<li>
スマートホームインテントはすべてaction.devices 名前空間に含まれているため、フルフィルメントを提供する必要があります。
</li>
<li>
Googleアシスタントがフルフィルメントにインテントを送信するたびに、ユーザーのサードパーティのOAuth 2アクセストークンがAuthorizationヘッダーで渡されます。
</li>
<li>
サポートされているスマートホームインテントは次のとおりです。
</li>
<ol>
<li>
SYNC
</li>
<li>
QUERY
</li>
<li>
EXECUTE
</li>
<li>
DISCONNECT
</li>
</ol>
</ul>

<h4>
SYNCインテント
</h4>

<ul>
<li>
このaction.devices.SYNCインテントは、ユーザーが接続して使用可能なスマートホームデバイスのリストを要求するために使用されます。
</li>
<li>
ユーザーがGoogle Homeアプリでデバイスをセットアップすると、クラウドインフラストラクチャに対しても認証されます。
</li>
<li>
次に、アシスタントはOAuth2トークンを受け取ります。
</li>
<li>
この時点で、Googleアシスタントはaction.devices.SYNCフルフィルメントにインテントを送信して、
ユーザーのデバイスと機能の初期リストをクラウドインフラストラクチャから取得します。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/smarthome001.png" width="100%">
<figcaption align="center">図1</figcaption>
</figure>

<ul>
<li>
ユーザーのアカウントのリンク解除と再リンクを回避するために、Googleアシスタントに同期リクエストを送信できます。
</li>
<li>
このaction.devices.SYNCにより、フルフィルメントにインテントが送信され、デバイスと機能のリストが同期されます。
</li>
<li>
詳細については、<a href="https://developers.google.com/assistant/smarthome/develop/request-sync">Request Syncの実装</a>を参照 してください。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/smarthome002.png" width="90%">
<figcaption align="center">図2</figcaption>
</figure>

<ul>
<li>
<a href="https://developers.google.com/assistant/smarthome/concepts/local">ローカルフルフィルメント</a>のセットアップ中に、ローカルホームプラットフォームは、
SYNCスマートホームアクションのクラウドフルフィルメントからの応答をチェックします。
</li>
<li>
SYNCローカルフルフィルメントをサポートするように応答を変更する方法の詳細については、<a href="https://developers.google.com/assistant/smarthome/develop/local#update_sync_response_in_the_cloud_fulfillment">クラウドフルフィルメントでのSYNC応答の更新</a>をご覧ください。
</li>
</ul>


<h4>
QUERYインテント
</h4>

<ul>
<li>
action.devices.QUERY意図は、スマートホームデバイスの現在の状態を照会するために使用されます。
</li>
<li>
ユーザーがデバイスのステータスを照会しているときに、Hey Googleなどの質問に答えるために、キッチンのどのライトがオンになっていますか？、Googleアシスタントがaction.devices.QUERYフルフィルメントにインテントを送信 します。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/query-diagram.png" width="90%">
<figcaption align="center">図3</figcaption>
</figure>

<ul>
<li>
最高のユーザーエクスペリエンスを実現するには、レポート状態を実装して 、ユーザーのデバイスの現在の状態をホームグラフに直接プロアクティブに報告する必要があります。
</li>
<li>
たとえば、これにより、ユーザーが物理的なライトスイッチでスマートライトをオンにしたかどうかがGoogleアシスタントに通知されます。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/smarthome004.png" width="90%">
<figcaption align="center">図4</figcaption>
</figure>

<h4>
EXECUTEインテント
</h4>

<ul>
<li>
このaction.devices.EXECUTEインテントは、スマートホームデバイスで実行するコマンドを提供するために使用されます。
</li>
<li>
ユーザーがGoogleアシスタントを使用してデバイスにコマンドを送信action.devices.EXECUTEすると、フルフィルメントは、
アクションと操作対象のデバイスを説明するフルフィルメントへのインテントを受け取ります。
</li>
<li>
ユーザーは、Hey Googleなどのコマンドを使用してデバイスでアクションを実行したり、リビングルームのライトをオンにしたりできます 。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/smarthome003.png" width="100%">
<figcaption align="center">図5</figcaption>
</figure>

<h4>
DISCONNECTンテント
</h4>

<ul>
<li>
このaction.devices.DISCONNECTインテントは、ユーザーがGoogleアシスタントからアプリアカウントのリンクを解除したときに通知するためにトリガーされます。
</li>
<li>
action.devices.DISCONNECTインテントを受け取った後は、このユーザーのデバイスの状態を報告しないでください。
</li>
</ul>

</div>



  </div> <!-- end of local-home -->

</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'DanceWorld',
  props: {
    msg: String
  },
  data() {
    return {
      albumIndex: 0,
      albumTitle : 'ワルツ',
      videoIndex: 0,
      videoTitle : '01 いきいきストレッチング',

      //videoIndex_1: 0,
      videoId: '5IlfzLYadNk',

      albums: [],
    }
  },
  created () {
    //this.albums = [this.album_1, this.album_2, this.album_3, this.album_4, this.album_5, this.album_6, this.album_7]
    //this.firstVideo()
  },
  methods: {
  
    selectAlbum(index) {
      window.console.log("selectAlbum() 1.index: " + index);
      this.albumIndex = index;
      this.firstVideo()
    },

  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smart-display {
  //margin-left: 20px;
}

.talka {
  margin-left: 10px;
}

pre {
background-color: #ffffaa;
}

h3 {
  margin: 40px 0 0;
}
ol {
  //list-style-type: none;
  padding: 0;
  margin-left: 20px;
}
ul {
  //list-style-type: none;
  padding: 0;
  margin-left: 20px;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
